import { useMemo } from 'react'
import { useUser } from '@/services/UserService'
import { getAnonymousId, useSafeAnalytics } from '@/utils/analytics'

export const useShopifyUserAttributes = (funnel: string, category: string, project_slug: string) => {
  const { userId } = useUser()
  const { user } = useSafeAnalytics()

  return useMemo(() => {
    const experimentData = {
      id: user()?.anonymousId,
      userId,
      anon_id: getAnonymousId() ?? user()?.anonymousId,
      timestamp: Date.now(),
      funnel,
      category,
      project_slug,
    }

    return [
      {
        key: 'gb_data',
        value: JSON.stringify(experimentData),
      },
    ]
  }, [category, funnel, project_slug, user, userId])
}
